import React, { useState } from "react";
import { PageWrapper } from "../containers";
import { FeedbackContainer } from "../containers/feedbacks-container/FeedbackContainer";


 const Feedbacks = () => {
  const [ isLoading, setIsLoading ] = useState(false);

  return <PageWrapper loading={isLoading} pageContainerChildren={
    <>
       <FeedbackContainer />
    </>
  } />;
};

export default Feedbacks;
